import { defineStore } from 'pinia'
import * as Sentry from '@sentry/vue'
import type { UserInfo } from '@/models/auth'
import type { THubSpotUser } from '~/models/hubspot'

export const useAuthStore = defineStore('auth-store', () => {
  const authenticated = ref(false)
  const token = ref(undefined)
  const userInfo = ref(null)
  const hubSpotUser = ref(null)
  const queriedUserData = ref(false)

  const isAuthenticated = computed(() => !!token.value && authenticated.value)
  const canPreviewContent = computed(() => !!userInfo.value?.canPreviewContent)
  const authChecked = computed(() => token.value !== undefined)

  function setToken(newToken: string | boolean) {
    token.value = newToken
  }

  function setUserInfo(info: UserInfo) {
    Sentry.setUser({ id: info.id, email: info.email, username: info.name })
    userInfo.value = info
  }

  function setPartialUserInfo(
    partialInfo: Pick<UserInfo, 'email' | 'company'>,
  ) {
    userInfo.value.email = partialInfo.email
    userInfo.value.company = partialInfo.company

    queriedUserData.value = true
  }

  function setAuthenticated(authenticatedValue: boolean) {
    authenticated.value = authenticatedValue
  }

  function setHubSpotUser(value: THubSpotUser) {
    hubSpotUser.value = value
  }

  function clear() {
    Sentry.setUser(null)
    token.value = false
    userInfo.value = null
    authenticated.value = false
  }

  return {
    authenticated,
    token,
    userInfo,
    hubSpotUser,
    isAuthenticated,
    canPreviewContent,
    authChecked,
    queriedUserData,
    setToken,
    setUserInfo,
    setPartialUserInfo,
    setAuthenticated,
    setHubSpotUser,
    clear,
  }
})
